import { render, staticRenderFns } from "./ImpersonationAlert.vue?vue&type=template&id=6084ea8c"
import script from "./ImpersonationAlert.vue?vue&type=script&lang=js"
export * from "./ImpersonationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports